<div class="sample-container" *ngIf="loadingData">
  <po-loading-overlay p-text="Carregando parceiros"></po-loading-overlay>
</div>

<div class="containerPage">
  <div class="containerPage--content">
    <img src="/assets/images/brand.png" alt="">

    <div class="content--text">
      <h1>Portal de Parceiros</h1>
      <strong>Boas-vindas, {{ userName }}</strong>
    </div>

    <div class="content--form" *ngIf="partners.length > 0">
      <div class="po-row">
        <po-select
          class="po-md-12"
          name="selectedPartner"
          p-label="Escolha a empresa"
          [p-options]="partners"
          (p-change)="handlePartner($event)"
        />
      </div>

      <div class="po-row">
        <po-button
          class="po-md-12"
          p-label="Continuar" 
          p-kind="primary"
          (p-click)="continueToHome()"
        />
      </div>
    </div>

    <div class="content--support" *ngIf="partners.length === 0">
      <p>
        Você não tem nenhuma empresa cadastrada no seu perfil. Entre em contato com o time de suporte para continuar.
      </p>
      
      <po-button
        class="po-md-12"
        p-label="Falar com suporte" 
        p-kind="primary"
        (p-click)="contactSupport()"
      />
    </div>
  </div>
</div>

<po-modal #modal p-size="sm" p-title="Nenhuma empresa cadastrada" (p-close)="contactSupport()">
  Você não tem nenhuma empresa cadastrada no seu perfil. Entre em contato com o time de suporte através do email <strong>{{ emailToContactSupport }}</strong>

  <po-modal-footer [p-disabled-align]="false">
    <po-button p-kind="primary" p-label="Entendi" (p-click)="contactSupport()" />
  </po-modal-footer>
</po-modal>